import * as React from "react";
import "./style.scss";
import _ from "lodash";
const d3 = require("d3-format");

export const Tooltip = React.createClass<any, {}>({
  renderText() {
    let { payload, valueKey, groupingKey } = this.props;
    let items = payload.map((entry: any, index: number) => {
      const color = entry.color || entry.payload.fill;
      const data = entry.dataKey || valueKey;
      let textStyle = { color: color };
      return (
        <li key={`tooptip-item-${index}`}>
          <span className="metric" style={textStyle}>
            {data.split("_").join(" ").toUpperCase()}{" "}
          </span>
          &nbsp;&nbsp;
          <span className="value" style={textStyle}>
            {entry.value != null ? d3.format(",")(entry.value) : "Unavailable"}
          </span>
        </li>
      );
    });
    return items;
  },
  render() {
    const { payload, groupingKey } = this.props;
    if (payload && payload.length > 0) {
      const showLabel = groupingKey != "master_flyer_item_name";
      const rawValue = payload[0].payload[groupingKey];
      const value = groupingKey == "date" ? rawValue : _.startCase(rawValue);
      const label = (
        <div className="tooltip-label">
          {groupingKey === "master_flyer_item_page_position"
            ? "Section"
            : _.startCase(groupingKey)}
        </div>
      );

      const title = showLabel ? (
        <div>
          {label}&nbsp;&nbsp;{value}
        </div>
      ) : (
        value
      );

      return (
        <div className="chart-tooltip">
          <span className="tooltip-title">{title}</span>
          <ul>{this.renderText()}</ul>
        </div>
      );
    }
    return null;
  }
});



// WEBPACK FOOTER //
// ./client/modules/core/Chart/common/Tooltip/index.tsx